'use client'

import React from 'react'

interface TabbedNavigationProps {
  tabs: Array<{ id: string; label: string; icon?: React.ReactNode }>;
  defaultActiveTab: string;
  // eslint-disable-next-line no-unused-vars
  onTabChange: (tabId: string) => void;
  theme: any;
  radius: number;
}

export default function TabbedNavigation({ 
  tabs, 
  defaultActiveTab, 
  onTabChange, 
  theme, 
  radius 
}: TabbedNavigationProps) {
  if (!tabs || tabs.length === 0) return null;

  return (
    <div className="flex flex-wrap justify-center gap-2 mb-12">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => onTabChange(tab.id)}
          className={`px-6 py-3 text-sm font-medium transition-all duration-200 flex items-center gap-2 font-primary ${
            tab.id === defaultActiveTab ? 'shadow-lg' : 'hover:shadow-lg'
          }`}
          style={{
            backgroundColor: tab.id === defaultActiveTab ? theme.accent : theme.card,
            color: tab.id === defaultActiveTab ? theme.onButton : theme.text,
            border: `1px solid ${tab.id === defaultActiveTab ? theme.accent : theme.border}`,
            borderRadius: radius,
            boxShadow: tab.id === defaultActiveTab ? `0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)` : 'none'
          }}
          onMouseEnter={(e) => {
            if (tab.id !== defaultActiveTab) {
              e.currentTarget.style.boxShadow = `0 0 0 3px ${theme.accent}40, 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)`;
            }
          }}
          onMouseLeave={(e) => {
            if (tab.id !== defaultActiveTab) {
              e.currentTarget.style.boxShadow = 'none';
            }
          }}
        >
          {tab.icon && <span>{tab.icon}</span>}
          {tab.label}
        </button>
      ))}
    </div>
  );
}
